import { useMemo } from 'react';
import type { StudioThemeId } from 'fym-shared/src/music24/studioThemes';
import type { PickLine } from '../fullVideoRules';
import type { StudioDetails } from '../studioRules';
import type { FrameLyric } from '../frames/assetFrameVars';

/**
 * The sung line of the step-3 previews: for a lyric moment, the first picked line (design s7b);
 * for the other asset types, the line of the song at the hook (`useFrameLyric`).
 */
export function usePreviewLyric(
  themeId: StudioThemeId,
  details: StudioDetails,
  lines: readonly PickLine[],
  fallback: FrameLyric | undefined
): FrameLyric | undefined {
  const { lineFrom } = details;
  return useMemo(() => {
    if (themeId !== 'lyricMoment' || lineFrom === undefined) {
      return fallback;
    }
    const position = lines.findIndex((line) => line.index === lineFrom);
    const current = lines[position];
    if (current === undefined) {
      return fallback;
    }
    return {
      prev: lines[position - 1]?.text ?? '',
      current: current.text,
      next: lines[position + 1]?.text ?? '',
    };
  }, [fallback, lineFrom, lines, themeId]);
}
